import React from "react";

export default function CarouselIconITextItem({ 
  icon, 
  text, 
  alt = "" 
}: {icon : string, text : string, alt : string}) : JSX.Element
{
  return (
    <div className="carousel-icon-item__container">
      <img src={icon} alt={alt} className="carousel-icon-item__icon" aria-hidden="true" />
      <p className="carousel-icon-item__text">{text}</p>
    </div>
  );
}
